import React from 'react'

import { PeopleSearchVisual } from '@/components/announcements/DiscoveryIntroModal/visuals'

export const PeopleIntelligencePreview: React.FC = () => (
  <figure className="relative my-6 h-[194px] overflow-hidden rounded-xl border border-primary-200 bg-gradient-to-b from-accent-400/15 via-violet-500/[0.06] to-transparent dark:border-primary-800">
    <PeopleSearchVisual />
    <figcaption className="sr-only">
      A natural-language people search returning relevant agency contacts with
      their roles and ways to reach them.
    </figcaption>
  </figure>
)

export default PeopleIntelligencePreview
